import { render, staticRenderFns } from "./PresentationEdit.vue?vue&type=template&id=513c12a9&scoped=true&"
import script from "./PresentationEdit.vue?vue&type=script&lang=js&"
export * from "./PresentationEdit.vue?vue&type=script&lang=js&"
import style0 from "./PresentationEdit.vue?vue&type=style&index=0&id=513c12a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c12a9",
  null
  
)

export default component.exports